import { render } from "./StyledRadioButton.vue?vue&type=template&id=58a6de02"
import script from "./StyledRadioButton.vue?vue&type=script&lang=js"
export * from "./StyledRadioButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__